import React, { Component } from 'react'
import Popover from 'react-popover'
import Scrollbars from 'react-custom-scrollbars'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import { isIE, isEdge } from 'react-device-detect'
import { withTranslation } from 'react-i18next'

import { EMOJIS } from 'app/constants/feed'
import { getUserInitials, getUserFullName } from 'helpers/getUserUIData'
import UserAvatarWithStats from 'app/components/UserAvatarWithStats/UserAvatarWithStats'

import './styles.scss'
const bc = 'feed-likes'
const hasMouseEvents = !isEdge && !isIE

class FeedLikes extends Component {
  state = {
    showTooltip: false,
  }

  tooltipHovered = false

  onButtonMouseEnter = debounce(() => this.onShowTooltip(), 400)

  onButtonMouseLeave = debounce(() => {
    if (!this.tooltipHovered) {
      this.onHideTooltip()
    }
  }, 400)

  onTooltipMouseEnter = () => {
    this.tooltipHovered = true
  }

  onTooltipMouseLeave = () => {
    this.tooltipHovered = false
    this.onHideTooltip()
  }

  onHideTooltip = () => {
    this.setState({ showTooltip: false })
  }

  onShowTooltip = () => {
    this.setState({ showTooltip: true })
  }

  onToggleTooltip = () => {
    this.setState({ showTooltip: !this.state.showTooltip })
  }

  renderUser = (user, key) => {
    const { firstName, lastName, avatar, email } = user
    const initials = getUserInitials(firstName, lastName, email)
    const fullName = getUserFullName(firstName, lastName)

    return (
      <div className={`${bc}__user`} key={'reacted-user' + key}>
        <div className={`${bc}__avatar`}>
          <UserAvatarWithStats
            isReactionPopup
            avatar={avatar}
            initials={initials}
            circleProps={{
              cx: 20,
              cy: 20,
              strokeWidth: 2,
              r: 19,
            }}
          />
        </div>
        <div className={`${bc}__fullname`}>{fullName}</div>
      </div>
    )
  }

  renderUsers = () => (
    <div className={`${bc}__users`} onMouseEnter={this.onTooltipMouseEnter} onMouseLeave={this.onTooltipMouseLeave}>
      <Scrollbars
        autoHeight
        autoHeightMax={252}
        renderThumbVertical={props => <div {...props} className="scrollbar-thumb-vertical" />}
      >
        {this.props.users.map(this.renderUser)}
      </Scrollbars>
    </div>
  )

  renderEmoji = (emoji, key) => {
    const icon = EMOJIS.find(item => item.name === emoji)

    if (!icon) {
      return null
    }

    return (
      <div className={`${bc}__emoji`} key={'reacted-emoji' + key}>
        {React.createElement(icon.icon)}
      </div>
    )
  }

  render() {
    const { t, likesCount, emojis } = this.props
    return (
      <div className={bc}>
        <Popover isOpen={this.state.showTooltip} preferPlace="above" place={null} tipSize={7} body={this.renderUsers()}>
          <div
            className={`${bc}__likes-container`}
            onMouseEnter={hasMouseEvents && this.onButtonMouseEnter}
            onMouseLeave={hasMouseEvents && this.onButtonMouseLeave}
            onClick={this.onToggleTooltip}
          >
            <div className={`${bc}__likes`}>{`${likesCount} ${t('likes')}`}</div>
            <div className={`${bc}__emojis`}>{emojis.map(this.renderEmoji)}</div>
          </div>
        </Popover>
      </div>
    )
  }
}

FeedLikes.propTypes = {
  emojis: PropTypes.array,
  likesCount: PropTypes.number,
  users: PropTypes.array,
}

export default withTranslation('user')(FeedLikes)
